export const FieldIsRequired = 'This field is required';